import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
export var Username = /*#__PURE__*/function () {
  function Username() {
    _classCallCheck(this, Username);
  }

  _createClass(Username, null, [{
    key: "isValid",
    value: function isValid(value) {
      return value.length >= this.minLength && value.length <= this.maxLength;
    }
  }]);

  return Username;
}();

_defineProperty(Username, "maxLength", 40);

_defineProperty(Username, "minLength", 5);